/**
 * Clickable chip that previews the analytical variable's source dataset.
 *
 * The agent stamps each analytical variable with a fully-qualified Snowflake reference like
 * ``EXPORT.AMGEN_ASTHMA_PRAGMATIC_REGISTRY_2026Q1`` — the same string the
 * platform uses as a dataset release id. Clicking the chip opens the same
 * ``DatasetDetailsModal`` the cohort builder surfaces from its info bar so
 * the epi can confirm the underlying release (size, date range, data types)
 * without leaving the chat.
 */

import { Chip } from '@mui/material';
import { useState } from 'react';

import { DatasetDetailsModal } from '@verantos-dev/ui-cohort-builder-components';

interface DatasetChipProps {
  dataset: string;
  testId?: string;
}

export const DatasetChip = ({ dataset, testId }: DatasetChipProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Chip
        size="small"
        label={`dataset: ${dataset}`}
        variant="outlined"
        clickable
        onClick={() => setOpen(true)}
        data-testid={testId}
        aria-label={`Preview dataset ${dataset}`}
        sx={{
          height: 22,
          fontSize: (theme) => theme.typography.caption.fontSize,
          '& .MuiChip-label': { fontFamily: 'monospace' },
        }}
      />
      {open && (
        <DatasetDetailsModal
          releaseId={dataset}
          releaseName={dataset}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  );
};
